import { render, staticRenderFns } from "./OtherParty.vue?vue&type=template&id=630d3b93&scoped=true"
import script from "./OtherParty.vue?vue&type=script&lang=ts"
export * from "./OtherParty.vue?vue&type=script&lang=ts"
import style0 from "./OtherParty.vue?vue&type=style&index=0&id=630d3b93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d3b93",
  null
  
)

export default component.exports